/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Mod6_BadgeInputs */

const es_landing_mod6_badge = /** @type {(inputs: Landing_Mod6_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista 6ª`)
};

const gl_landing_mod6_badge = /** @type {(inputs: Landing_Mod6_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista 6ª`)
};

const en_landing_mod6_badge = /** @type {(inputs: Landing_Mod6_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List 6`)
};

/**
* | output |
* | --- |
* | "List 6" |
*
* @param {Landing_Mod6_BadgeInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_mod6_badge = /** @type {((inputs?: Landing_Mod6_BadgeInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Mod6_BadgeInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_mod6_badge(inputs)
	if (locale === "en") return en_landing_mod6_badge(inputs)
	return es_landing_mod6_badge(inputs)
});